export default {
  title: "Course Questionnaire",
  message: "The information you provide helps us personalize the course to your preferences, creating a better learning experience for you.",
  buttons: {
    submit: "Start Course",
    cancel: "Cancel",
  },
  success: "Form submitted successfully",
  errors: {
    loadFailed: "Failed to load form",
    submitFailed: "Failed to submit form",
  },
};
